import React from "react";

import "./AvailableFunds.scss";
import useVipAccountCache from "Utils/Hooks/useVipAccountCached";
import AvailableFundsBase from "./AvailableFundsBase";
import useSession from "Utils/Hooks/useSession";
import { PRODUCTTYPES } from "Utils/Constants";
import { AddTrailingZeros } from "Utils/Utils";
//import useCacheData from "Components/useCacheData";

const AvailableFunds = ({ fundingSource }) => {
  const { vipAccount } = useVipAccountCache();
  const { session } = useSession();
  const isVipOnline = session?.patronProductType === PRODUCTTYPES.ONLINE;
  const productType = session?.patronProductType === PRODUCTTYPES.PREFERRED ? 'VIP Preferred' : 'VIP Online';
  // const selectedFundDetails = window.sessionStorage.getItem("selectedFundDetails") ? JSON.parse(window.sessionStorage.getItem("selectedFundDetails")) : null;

  const availableFunds = isVipOnline ? (fundingSource && fundingSource.availableLimit ? fundingSource.availableLimit : 0) : vipAccount?.availableAmount;
  const limitAmount = isVipOnline ? (fundingSource && fundingSource.totalLimit ? AddTrailingZeros(fundingSource.totalLimit) : 0) : AddTrailingZeros(vipAccount?.limitAmount?.toLocaleString());


  const message = isVipOnline ? "This amount is available limit in your selected checking account of VIP Online. As you deposit funds from your bank account, your available limit will decrease." : `This amount is your available limit from ${productType}. We provide a $${limitAmount} limit. As you deposit funds from your bank account, your available limit will decrease.`;

  return (
    <>
      {limitAmount ? <AvailableFundsBase availableFunds={availableFunds} limitAmount={limitAmount} headerText="AVAILABLE LIMIT" tooltipText={message} /> : <AvailableFundsBase availableFunds={availableFunds} limitAmount={"0.00"} headerText="AVAILABLE LIMIT" tooltipText={message} />}
    </>
  );
};

export default AvailableFunds;